export default __webpack_public_path__ + "static/media/ODC2.771b4e06.svg";